import React, { useState, useEffect } from 'react';
import { makeStyles } from "@material-ui/core";
//import bannerImage from "../../img/main_banner_bg.png"
import Carousel from "react-material-ui-carousel"
import { getBanner } from '../../functions/banner';
import CircularProgress from '@material-ui/core/CircularProgress';
const useStyles = makeStyles(theme => ({

    bannerStyle: {
        width: "900px",
        height: "370px",
        margin: "45px 0 45px 40px",
        // margin: " 45px auto",
        backgroundColor: "#11ffee00",
        borderRadius: "10px",
        "@media (max-width: 770px)": {
            width: "100%",
            height: "200px",
            margin: "10px 0px",
            padding: "0px",

        }
    },

}));

const Banner = () => {

    const style = useStyles();

    const [banner, setBanner] = useState([{ image_url: [] }]);

    useEffect(() => {
        getBanner().then(res => {
            console.log(res);
            setBanner([...res]);
        }).catch(err => {
            console.log(err);
        })
    }, [])


    return (
        <>
            {
                banner.length === 1 ?
                    <CircularProgress />
                    :
                    <Carousel animation="slide" duration={4000} indicators={false} navButtonsAlwaysInvisible={true}>

                        {banner.map((item, index) => (

                            <img key={index} src={item.image_url} alt="banner" className={style.bannerStyle} />

                        ))}

                    </Carousel>
            }
        </>

    );
};

export default React.memo(Banner);